import { Locate, MapPinOff } from "lucide-react";
import { Button } from "../components/ui/button";
import { useLiveTrack } from "../hooks/useLiveTrack";

/**
 * TrackLauncher — appears in the AlertFeed footer for the alert creator
 * (the citizen who reported it). Only the creator sees this; everyone else
 * sees the moving pin on the map once the creator starts tracking.
 *
 * Off  → black "Share live location" button
 * On   → red pulsing "Stop tracking · N pts" button
 */
export default function TrackLauncher({ alert, user }) {
  const isCreator = alert?.user_id && user?.user_id && alert.user_id === user.user_id;
  const { active, pointCount, start, stop } = useLiveTrack(alert?.alert_id);

  if (!isCreator) return null;
  if (alert.status === "resolved") return null;

  if (!active) {
    return (
      <Button
        variant="outline"
        size="sm"
        onClick={start}
        data-testid={`track-start-${alert.alert_id}`}
        className="rounded-sm border-gray-300 text-gray-700 hover:bg-gray-50 text-xs font-bold"
      >
        <Locate className="w-3.5 h-3.5 mr-1.5" /> Share live location
      </Button>
    );
  }

  return (
    <Button
      size="sm"
      onClick={stop}
      data-testid={`track-stop-${alert.alert_id}`}
      className="rounded-sm bg-red-600 hover:bg-red-700 text-white text-xs font-bold"
      title="Stop sharing live location"
    >
      <span className="relative inline-flex items-center mr-1.5" aria-hidden>
        <span className="absolute inline-flex h-2 w-2 animate-ping rounded-full bg-white opacity-75" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-white" />
      </span>
      <MapPinOff className="w-3.5 h-3.5 mr-1.5" /> Stop tracking
      <span className="ml-1.5 font-mono opacity-80">· {pointCount} pts</span>
    </Button>
  );
}
